import React from 'react';
import { Outlet } from 'react-router';
import { Link } from 'react-router-dom';

const AdminConferenceMain = () => {

return (
    <>
    <div style={{ display: 'flex'}}>
        <div style={{ flex: "50%"}}>
            <p className='lead text-dark' style={{ padding: "1rem"}}>Conference</p>
        </div>
        <div style={{ flex: "50%", paddingTop: "1rem"}}>
            <Link to='all'><button type="button" className="btn btn-outline-warning">All Conferences</button></Link>
            <Link to='bookings'><button type="button" className="btn btn-outline-primary">Conference Bookings</button></Link>
            <Link to='add'><button type="button" className="btn btn-outline-success">Add Conference</button></Link>
        </div>
    </div>
    <hr style={{padding: "0px"}}/>
    <Outlet />
    </>
)};

export default AdminConferenceMain;